<template>
	<main class="Login">
		<div class="Login_row d-flex align-center">
			<figure class="Login_pic flex-grow-1">
				<img src="@/assets/img/login3.jpg" alt="Venuelocity Login" />
			</figure>

			<aside class="Login_aside flex-shrink-0">
				<img
					class="Login_logo mb-8"
					:src="require('@/assets/img/logo-login1.svg')"
					alt="Venuelocity Logo"
				/>
				<form
					class="Login_form"
					@submit.prevent="checkLogin"
					v-if="!isFirstLogin && !showTwoFACode"
				>
					<div class="Login_field">
						<label>Username</label>
						<input
							v-model="username"
							placeholder="Username"
							type="text"
						/>
					</div>
					<div class="Login_field">
						<label>Password</label>
						<input
							v-model="password"
							placeholder="Password"
							type="password"
						/>
					</div>
					<div
						class="Login_foot d-flex align-center justify-space-between mt-4"
					>
						<div class="Login_foot-remember">
							<input
								type="checkbox"
								name="remember-me"
								id="remember-me"
								v-model="rememberMe"
							/>
							<label for="remember-me">Remember Me</label>
						</div>

						<router-link class="link" to="/forgot-password"
							>Forgot Password?</router-link
						>
					</div>
					<div class="Login_submit d-flex justify-center mt-8">
						<v-btn color="primary" type="submit" link>Login</v-btn>
					</div>
				</form>
				<ResetPassword v-if="isFirstLogin" />
				<TwoFACode v-if="showTwoFACode" />
				<v-overlay :value="overlay">
					<v-progress-circular
						indeterminate
						size="64"
					></v-progress-circular>
				</v-overlay>
				<v-alert
					v-if="showError"
					:icon="false"
					dense
					class="mt-5"
					id="error"
					type="error"
					>{{ messageAlert }}</v-alert
				>
			</aside>
		</div>
	</main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ResetPassword from "@/components/Login/ResetPassword";
import TwoFACode from "@/components/Login/TwoFACode";

export default {
	name: "Login",
	components: {
		ResetPassword,
		TwoFACode,
	},
	data() {
		return {
			username: "",
			password: "",
			showError: false,
			messageAlert: "Username or Password is incorrect",
			overlay: false,
			isFirstLogin: false,
			showTwoFACode: false,
			rememberMe: false,
		};
	},
	computed: {
		...mapGetters({ User: "StateUser", getRememberMe: "StateRememberMe" }),
	},
	beforeMount() {
		if (this.User == null || this.User.isLogin == false) {
			this.isFirstLogin = false;
			this.showTwoFACode = false;
		} else if (this.User.isFirstLogin === true) {
			this.isFirstLogin = true;
			this.showTwoFACode = false;
		} else if (this.User.isFirstLogin === false && this.User.twoFA == 1) {
			this.isFirstLogin = false;
			this.showTwoFACode = true;
		} else if (this.User.isFirstLogin === false && this.User.twoFA == 0) {
			this.isFirstLogin = false;
			this.showTwoFACode = false;
			console.log("Disabled");
		} else {
			console.log("User--->", this.User);
			this.checkSession();
		}
		if (this.getRememberMe !== "") {
			this.rememberMe = true;
			this.username = this.getRememberMe;
		}
	},
	methods: {
		...mapActions(["logIn", "requestTwoFACode", "checkSession"]),
		async checkLogin() {
			this.showError = false;
			this.overlay = !this.overlay;
			const User = new FormData();
			User.append("username", this.username);
			User.append("password", this.password);
			User.append("rememberMe", this.rememberMe);
			try {
				const { total_properties, urlReturn, properties } =
					await this.logIn(User);
				console.log("Auth Service ----");
				this.username = "";
				this.password = "";
				this.messageAlert = "";
				this.showError = false;
				this.overlay = false;

				if (this.User.isFirstLogin === true) {
					this.isFirstLogin = true;
					return false;
				}

				if (this.User.twoFA == 1) {
					const params = new FormData();
					params.append("admin_id", this.User.id);
					const result = await this.requestTwoFACode(params);
					this.isFirstLogin = false;
					this.showTwoFACode = true;
					return false;
				} else {
					console.log("User dissabled 2FA");
					this.User.isLogin = true;
					this.$store.commit("setUser", this.User);
				}

				if (
					this.$router.currentRoute.query.redirect !== undefined &&
					total_properties > 1
				) {
					const dataUrl =
						this.$router.currentRoute.query.redirect.split("/");
					const siteId = dataUrl[2];
					if (siteId === undefined) {
						this.$router.push(
							this.$router.currentRoute.query.redirect
						);
						return false;
					}
					const property = properties.find((property) => {
						return property.sites.find(
							(site) => site.site_id == siteId
						);
					});
					const sites = property.sites;
					const site = sites.find((site) => {
						return site.site_id == siteId;
					});
					this.$store.commit(
						"setPropertySeleted",
						property.property_seoname
					);
					this.$store.commit("setSites", sites);
					this.$store.commit("setSiteSelected", site.site_id);
					this.$store.commit("setTypeSelected", site.propertyType);
					this.$store.commit("setShowTotalRev", site.showTotalRev);
					this.$store.commit("setShowFeesInv", site.showFeesInv);
					this.$store.commit("setShowOutbound", site.showOutbound);
					this.$router.push(this.$router.currentRoute.query.redirect);
				} else this.$router.push(urlReturn);
			} catch (err) {
				if (
					err.response !== undefined &&
					err.response.status !== undefined &&
					err.response.status === 405
				) {
					this.messageAlert = err.response.data.error;
					this.showError = true;
				} else {
					console.error(err);
				}
				setTimeout(() => {
					this.overlay = false;
				}, 2000);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors.scss";
.Login {
	&_row {
		height: auto;
		min-height: 100vh;
	}
	&_pic {
		align-self: stretch;
		display: block;
		max-width: 65%;
		height: auto;
		max-height: 100vh;
		padding: 30px;
		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 6px;
		}
	}
	&_aside {
		display: block;
		width: 320px;
		margin: auto;
		padding-right: 30px;
	}
	&_logo {
		display: block;
		width: auto;
		max-width: 100%;
		height: auto;
		margin: auto;
	}
	&_form {
		display: block;
		width: 100%;
		margin: 0;
	}
	&_field {
		display: block;
		margin-bottom: 20px;
		position: relative;
		label {
			width: 0;
			height: 0;
			visibility: hidden;
			position: absolute;
			opacity: 0;
		}
		input {
			font-size: 14px;
			display: block;
			width: 100%;
			height: 35px;
			padding: 0 20px;
			border: 1px solid #bfbfbf;
			border-radius: 4px;
			&::placeholder {
				color: #bfbfbf;
			}
		}
	}
	&_foot {
		&-remember {
			font-size: 12px;
			color: #bfbfbf;
			display: block;
			cursor: pointer;
			input {
				display: block;
				width: 0;
				height: 0;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 0;
				opacity: 0;
				visibility: hidden;
				&:checked + label {
					&::before {
						background: $purple;
					}
				}
			}
			label {
				flex: 1 1;
				display: flex;
				align-items: center;
				gap: 0.3em;
				cursor: pointer;
				&::before {
					display: block;
					width: 0.8em;
					height: 0.8em;
					border: 2px solid #ffffff;
					outline: 1px solid #bfbfbf;
					transition: background 0.3s;
					content: "";
				}
			}
		}
	}
	.link {
		font-size: 12px;
		color: #bfbfbf;
		font-weight: 500;
	}
	.v-btn {
		min-width: 140px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue